__turbopack_context__.v({
  "root": "StatBox-module__P5zkJa__root",
});
